import * as yup from 'yup';

export type EmptySearchHistoryRequest = {
	name: string;
};

export const saveHistoryFormValidationSchema: yup.SchemaOf<EmptySearchHistoryRequest> = yup.object().shape({
	name: yup.string().required('Enter search name').min(2).max(50)
});
